import { BarometerChart, QuickViewReferenceValue, QuickViewWidget, useScrollIntoView } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

const WIDGET_NAME = 'ManagedSupplierWidget';

export const ManagedSupplierWidget = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'risk-supplier-managed' });

  const totalSupplier = 240;
  const managedSupplier = 190;
  const percentageManaged = (managedSupplier / totalSupplier) * 100;
  const success = percentageManaged >= 90 ? 'success' : 'warning';

  return (
    <QuickViewWidget
      ref={widgetRef}
      active={active}
      title={t('title')}
      subTitle={t('subTitle')}
      value={managedSupplier}
      referenceValue={<QuickViewReferenceValue description={t('total')} value={totalSupplier} dotColor={success} />}
      data-intercom-target={WIDGET_NAME}
    >
      <BarometerChart
        color={success}
        width={128}
        height={70}
        value={managedSupplier}
        min={0}
        max={totalSupplier}
        dotColor={success}
      />
    </QuickViewWidget>
  );
};
